import React, { useEffect, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import { GoArrowRight, GoArrowLeft } from "react-icons/go";
import { FcCancel } from "react-icons/fc";
import { AiFillMinusSquare } from "react-icons/ai";
import MainSignataireModal from '../../components/Modal/SignataireModal/MainSignataireModal';
import MotifModal from '../../components/Modal/SignataireModal/MotifModal';
import { PDFDocument } from 'pdf-lib'
import { SignatairesSelector } from '../../services/reduxSlices/SignataireSlice';
import { signatureSelector } from '../../services/reduxSlices/SignatureSlice';
import { useSelector } from 'react-redux'
import './SignatairesStyles.css'
import Cookies from 'js-cookie';

/**
 * 
 * Page de prévisualisation des documents
 * @param {} param0 
 * @returns PreviewDoc
 */
export default function PreviewDoc() {
    
    const getDownloadDocument = async ({ currentFile, x, y, page, image, hvSignataire }) => {
        const existingPdfBytes = await fetch(currentFile).then(res => res.arrayBuffer())
        const pdfDoc = await PDFDocument.load(existingPdfBytes)

        // get canvas images

        const jpgImage = await pdfDoc.embedPng(hvSignataire ? image : dataURLToArrayBuffer(image))

        const pages = pdfDoc.getPages()

        const pageH = pages[page - 1 || 0].getHeight()

        pages[page - 1 || 0].drawImage(jpgImage, {
            x: x > 315 ? (x + 20) / 1.333 : (x - 5) / 1.333,
            y: y > (pageH / 2) ? (pageH - 120) - (y / 1.333) : (pageH - 90) - (y / 1.333),
            width: 80,
            height: 80,
        })

        const pdfBytes = await pdfDoc.save()

        const pdfFile = new File([pdfBytes], 'document.pdf', { type: 'application/pdf' });
        //download(pdfFile, 'reegegh.pdf', 'application/pdf')

        return pdfFile
    }

    function fileToArrayBuffer(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = function (event) {
                const arrayBuffer = event.target.result;
                resolve(arrayBuffer);
            };

            reader.onerror = function (event) {
                reject(event.target.error);
            };

            reader.readAsArrayBuffer(file);
        });
    }

    function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.split(',')[1];
        var binaryString = window.atob(base64);
        var length = binaryString.length;
        var bytes = new Uint8Array(length);

        for (var i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return bytes.buffer;
    }

    const { signataire, currentDoc, status } = useSelector(SignatairesSelector)
    const { image, text, draw, choice } = useSelector(signatureSelector)

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [isCancel, setIsCancel] = useState(false)
    const [motif, setMotif] = useState('')
    const [imIsChosing, setImIsChosing] = useState(false)
    const [imgCode, setImgCode] = useState(null)

    const [copyDocument, setCopyDocument] = useState(null)

    useEffect(() => {
        const pngUrl = 'https://dkbsign.com/assets/media/home_icon/square.png'

        fetch(pngUrl).then((res) => res.arrayBuffer().then(re => re)).then(pngImageBytes => getDownloadDocument({
            currentFile: currentDoc.document,
            y: currentDoc.positionY,
            x: currentDoc.positionX,
            page: currentDoc.page,
            image: pngImageBytes,
            hvSignataire: true
        }).then(res => setCopyDocument(res)))
    }, [])


    const formatTextToImg = (text) => {
        var c = document.getElementById("signature-canvas");
        var ctx = c.getContext("2d");
        ctx.font = "50px Dancing Script";
        ctx.strokeText(text, 10, 50);

        return c.toDataURL()
    }

    const signDocument = async () => {

        const DPI = 75
        const MMM = 25.4

        var canvas = document.getElementById("signature-canvas");
        var ImagedataURL = canvas.toDataURL();

        const file = await getDownloadDocument({
            currentFile: currentDoc.document,
            y: currentDoc.positionY,
            x: currentDoc.positionX,
            page: currentDoc.page,
            image: ImagedataURL
        })

        const datasended = {
            "Key_Api": "test@dkbsign7",
            "Id_cl": "0708155815",
            "signataire": "",
            "signataire2": "",
            "posX_signataire2": "",
            "posY_signataire2": "",
            "signataire3": "",
            "posX_signataire3": " ",
            "posY_signataire3": " ",
            "nbre_signatair": "1",
            "Code_ctr": "cl07",
            "nom_ctr": currentDoc.document,
            "posX": (currentDoc.positionY / DPI) * MMM,
            "posY": (currentDoc.positionX / DPI) * MMM,
            "posX_qr": "",
            "posY_qr": "",
            "taille_qr": 20,
            "img_signataire_png": imgCode,
            "format_img_signataire": 1,
            "posX_Imgsign": (currentDoc.positionY / DPI) * MMM,
            "posY_Imgsign": (currentDoc.positionX / DPI) * MMM,
            "page_sign": currentDoc.page,
            "Largeur_img_signataire_png": 40,
            "Hauteur_img_signataire_png": 16,
            "initial": "",
            "qrcodeyes": "0"
        }

        const formData = new FormData();
        formData.append("data", JSON.stringify(datasended));
        formData.append('document', file)

        const token = Cookies.get('token')

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData,
            redirect: 'follow'
        };

        fetch(`https://dkbsign.com/new_api_dkbsign/public/api/signatures/accepter?document=${currentDoc.document}&token=${signataire}&code_auth=${currentDoc.code_auth}`, requestOptions)
            .then(result => {
                console.log(result.json())
                window.location.href = `/signataires/?signataire=${signataire}`
            })
            .catch(error => {
                console.log(error)
            });
    }

    const cancelDocument = () => {
        const datasended = {
            "Key_Api": "test@dkbsign7",
            "Id_cl": "0708155815",
            "signataire": "",
            "signataire2": "",
            "posX_signataire2": "",
            "posY_signataire2": "",
            "signataire3": "",
            "posX_signataire3": " ",
            "posY_signataire3": " ",
            "nbre_signatair": "1",
            "Code_ctr": "cl07",
            "nom_ctr": currentDoc.document,
            "posX": currentDoc.positionX * 0.264,
            "posY": currentDoc.positionY * 0.264,
            "posX_qr": "",
            "posY_qr": "",
            "taille_qr": 20,
            "img_signataire_png": image,
            "format_img_signataire": 1,
            "posX_Imgsign": currentDoc.positionX * 0.264,
            "posY_Imgsign": currentDoc.positionY * 0.264,
            "page_sign": currentDoc.page,
            "Largeur_img_signataire_png": 40,
            "Hauteur_img_signataire_png": 16,
            "initial": "",
            "qrcodeyes": "0"
        }

        const formData = new FormData();
        formData.append("data", JSON.stringify(datasended));
        formData.append("motif", motif);
        const token = Cookies.get('token')

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData,
            redirect: 'follow'
        };

        fetch(`https://dkbsign.com/new_api_dkbsign/public/api/signatures/refuser?document=${currentDoc.document}&token=${signataire}&code_auth=${currentDoc.code_auth}`, requestOptions)
            .then(result => {
                console.log(result.json())
                window.location.href = `/signataires/?signataire=${signataire}`
            })
            .catch(error => {
                console.log(error)
            });
    }

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    }, [])

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    useEffect(() => {
        if (imIsChosing) {
            if (choice === 'text') {
                var c = document.getElementById("signature-canvas");
                var ctx = c.getContext("2d");
                ctx.font = "50px Dancing Script";
                ctx.strokeText(text, 100, 100);

                var dataURL = c.toDataURL();
                setImgCode(dataURL)
            } else if (choice === 'image') {
                setImgCode(image)
            } else {
                setImgCode(draw)
            }

            //signDocument()
        }
        if (isCancel) cancelDocument()
    }, [imIsChosing, isCancel])

    return (
        <React.Fragment>
            <MainSignataireModal setImIsChosing={setImIsChosing} />
            <MotifModal setIsCancel={setIsCancel} setMotif={setMotif} />
            <div className='content-sign'>
                <div className="container-page">
                    <div className="btn-pages">

                        {
                            pageNumber === 1 ?
                                (
                                    <div className="btn-switch" href="#" ><AiFillMinusSquare color='white' size={20} /></div>
                                ) :
                                (
                                    <div className="btn-switch" href="#" onClick={() => {
                                        pageNumber !== 1 && setPageNumber(pageNumber - 1)
                                    }}><GoArrowLeft color='white' size={20} /></div>
                                )
                        }

                        {
                            pageNumber === numPages ?
                                (
                                    <div className="btn-switch" href="#" ><AiFillMinusSquare color='white' size={20} /></div>
                                ) :
                                (
                                    <div className="btn-switch" href="#" onClick={() => {
                                        pageNumber !== numPages && setPageNumber(pageNumber + 1)
                                    }}><GoArrowRight color='white' size={20} /></div>
                                )
                        }

                    </div>

                    <div className='docview' onMouseDown={() => false} onSelect={() => false}>
                        <p style={{ color: 'black', margin: '5px' }}>Page <input className="btn-page" min="1" type="number" value={pageNumber} onChange={(e) => {
                            if (e.currentTarget.value === '') setPageNumber(0)
                            if (parseInt(e.currentTarget.value) <= numPages) {
                                setPageNumber(parseInt(e.currentTarget.value))
                            }
                        }} /> of {numPages}</p>

                        {status !== 'signe' && <canvas style={{ display: 'none' }} id="signature-canvas"></canvas>}
                        <div className="document">
                            <Document file={copyDocument} onLoadSuccess={onDocumentLoadSuccess}>
                                {
                                    (status !== 'signe' && currentDoc.page === pageNumber) &&
                                    <div style={{ top: currentDoc.positionY, left: currentDoc.positionX }} className="box-sign">
                                        <img src={imgCode ? imgCode : null} style={{ width: '100px', height: '100px' }} alt="Placer une signature ou qrcode" />
                                    </div>
                                }
                                <Page bookmark="Harry Potter and the Philosopher's Stone" width={600} pageNumber={pageNumber} />
                            </Document>
                        </div>
                        {
                            (status !== 'signe' && imgCode === null) ?
                                <div className="actions-signataire">
                                    <a href="#" className="me-4 btn btn-bg-white btn-active-color-primary btn-wh option-item" data-bs-toggle="modal" data-bs-target="#MainSignataireModal">
                                        <i className="bi bi-person-check-fill"></i> Signer
                                    </a>
                                    <a href="#" className="me-4 btn btn-bg-white btn-active-color-primary btn-wh option-item cancel" data-bs-toggle="modal" data-bs-target="#MotifModal">
                                        <FcCancel size={20} /> Réfuser
                                    </a>
                                </div> :
                                <div className="actions-signataire">
                                    <a
                                        href="#"
                                        className="me-4 btn btn-bg-white btn-active-color-primary btn-wh option-item"
                                        onClick={async () => {
                                            await signDocument()
                                        }}
                                    >
                                        <i className="bi bi-person-check-fill"></i> Valider
                                    </a>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
